exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DialogsList{background-color:#f1f1f1;height:100%}.DialogsList .HeaderDialog{background-color:#00adff;display:flex;align-items:center;justify-content:center;height:55px;font-size:18px;color:#fff}.DialogsList .item{cursor:pointer;padding:10px 15px}.DialogsList .item .rowList{display:flex;align-items:center;justify-content:space-between}.DialogsList .item .date{color:#646464;font-size:14px}.DialogsList .item .name{color:#646464;font-size:18px}.DialogsList .item.active{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/AdminPanel/SupportQuestion/components/DialogsList/styles.scss
// module id = 4478
// module chunks = 0